export default __webpack_public_path__ + "static/media/GB-NIR.2b5d81cd.svg";